module.exports = __webpack_public_path__ + "img/logoEifoanyBlue.3ec8a1b2.png";